import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function FormGroup({ children, className }) {
	return (
		<div className={classnames('ss-form-group', className)}>{children}</div>
	);
}

FormGroup.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};
